import { supabase } from "@/integrations/supabase/client";
import type { Summary } from "./types";

export async function getSummaries(userId: string, contentId?: string | null): Promise<Summary[]> {
  let query = supabase
    .from("summaries")
    .select("*")
    .eq("user_id", userId)
    .order("created_at", { ascending: false });

  if (contentId) {
    query = query.eq("content_id", contentId);
  }

  const { data, error } = await query;

  if (error) {
    console.error("Error fetching summaries:", error);
    throw error;
  }

  return (data || []).map(row => ({
    ...row,
    ranges: (row.ranges as { start: string; end: string }[]) || []
  }));
}

export async function createSummary(params: {
  userId: string;
  contentId?: string | null;
  title: string;
  type: string;
  content?: string | null;
  template?: string | null;
  ranges?: { start: string; end: string }[];
}): Promise<Summary> {
  const { data, error } = await supabase
    .from("summaries")
    .insert({
      user_id: params.userId,
      content_id: params.contentId || null,
      title: params.title,
      type: params.type,
      content: params.content || null,
      template: params.template || null,
      ranges: params.ranges || []
    })
    .select()
    .single();

  if (error) {
    console.error("Error creating summary:", error);
    throw error;
  }

  return {
    ...data,
    ranges: (data.ranges as { start: string; end: string }[]) || []
  };
}

export async function updateSummaryTitle(summaryId: string, title: string): Promise<void> {
  const { error } = await supabase
    .from("summaries")
    .update({ title })
    .eq("id", summaryId);

  if (error) {
    console.error("Error updating summary title:", error);
    throw error;
  }
}

export async function deleteSummary(summaryId: string): Promise<void> {
  const { error } = await supabase
    .from("summaries")
    .delete()
    .eq("id", summaryId);

  if (error) {
    console.error("Error deleting summary:", error);
    throw error;
  }
}